import React, { useState, useEffect } from "react";
import axios from "axios";
import NavbarComponent from "./NavbarComponent";
import Footer from "./Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import {  useParams } from "react-router-dom";
import API_URLS from './apiConfig';

const ExploreAIStrategyAdvisory = () => {
  const imageUrl = API_URLS.baseUrl;
  const homeUrl=API_URLS.baseFrontUrl;
  const { id } = useParams();
  const { pagename } = useParams();
  const defaultlang = API_URLS.defaultLang;
  const [cards, setCards] = useState('');
  const [cardsdetails, setCardsDetails] = useState([]);

  useEffect(() => {
    axios
    .get(API_URLS.getAllDetails+`/${pagename}/${id}/${defaultlang}`)
    .then((response) => {
      console.log(response.data);
      setCards(response.data);
      setCardsDetails(response.data.repeater_data);
    })
    .catch((error) => {
      console.error("Error fetching menu data:", error);
    });
}, [pagename, id, defaultlang]);

  // const cards = [
  //   {
  //     id: 1,
  //     title: "Our Perspective on AI",
  //     description: "How can AI reshape industries and create a more equitable world?",
  //     category: "Perspective",
  //     image: "/images/010.jpg",
  //     link: "/perspective",
  //   },
  //   {
  //     id: 2,
  //     title: "Customer Stories",
  //     description: "What's possible when technology meets purpose-driven transformation?",
  //     category: "Stories",
  //     image: "/images/011.jpg",
  //     link: "/stories",
  //   },
  //   {
  //     id: 3,
  //     title: "Global Studies",
  //     description: "What can global trends teach us about building a sustainable future?",
  //     category: "Studies",
  //     image: "/images/012.jpg",
  //     link: "/studies",
  //   },
  //   {
  //     id: 4,
  //     title: "AI in Action",
  //     description: "Discover the real-world applications of AI across industries.",
  //     category: "Action",
  //     image: "/images/010.jpg",
  //     link: "/action",
  //   },
  // ];

  return (
    <>
      <NavbarComponent />
      <div className="ExploreAIStrategyAdvisory">
        <div className="container">
          <h1 className="ExploreAIStrategyAdvisory-header">{cards.title}</h1>
          <div className="row">
            <div className="content col-md-12">
              <div className="landing-page-div" dangerouslySetInnerHTML={{ __html: cards.content }} />
            </div>
          </div>

          {/* Carousel Section */}
          <Swiper
            spaceBetween={20}
            slidesPerView={3}
            navigation={{ clickable: true }}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop
            className="carousel-container"
            modules={[Navigation, Pagination, Autoplay]}
            breakpoints={{
              // Settings for larger screens
              1024: {
                slidesPerView: 3, // Always show 3 slides for desktops
              },
              768: {
                slidesPerView: 2, // 2 slides for tablets
              },
              0: {
                slidesPerView: 1, // 1 slide for mobile
              },
            }}
          >
            {cardsdetails.map((card, index) => (
              <SwiperSlide key={index} className="carousel-item">
                <div className="slider-card">
                  <div
                    className="slider-card-background"
                    style={{ backgroundImage: `url(${card.image ? `${imageUrl}${card.image}` : "/images/default-image.jpg"})` }}
                  ></div>
                  <div className="slider-card-content">
                    <h5 className="card-title">{card.title}</h5>
                    <h3 className="card-category">{card.sub_title}</h3>
                  </div>
                  <div className="slider-card-hover">
                    <p className="hover-description">{card.description}</p>
                    {card.button_name!=='' ? <a href={homeUrl+card.api_link}>{card.button_name}</a> : ''}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        </div>
      </div>
      <Footer />
    </>
  );
};

export default ExploreAIStrategyAdvisory;
